import { useParams } from 'react-router-dom';
import { Ruthie } from '../../components/Ruthie';

export default function RuthieConversationPage() {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="h-screen w-full flex flex-col">
      <div className="flex-shrink-0 p-4 border-b border-border">
        <h1 className="text-2xl font-bold text-foreground">Data Architect</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Design your semantic layer through natural conversation with Ruthie.
        </p>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        {id && <Ruthie showHistory={true} conversationId={id} />}
      </div>
    </div>
  );
}
